import { userCache } from '@mentimeter/user';
import useSWR from 'swr';
import {
  getInvitesRequest,
  getInvitesResponse,
} from '@core-api/workspace-members/workspace-members/invites/{token}';
import { captureException } from '@sentry/nextjs';
import type { JoinErrorEnum } from '../join-page/handleErrorMessage';
import { InviteError } from '../../errors/InviteError';

const CACHE_KEY = '/use-invite';

interface UseInviteOptions {
  onError: (error: InviteError) => void;
}

export function useInvite(token: string | null, { onError }: UseInviteOptions) {
  const fetcher = async () => {
    if (!token) return null;

    const response = await fetch(
      getInvitesRequest({ region: userCache.region, token }),
    );

    if (!response.ok) {
      const body = (await response.json().catch()) as
        | { code?: JoinErrorEnum }
        | undefined;

      throw new InviteError(body?.code);
    }

    return getInvitesResponse(response);
  };

  return useSWR(token ? CACHE_KEY : null, fetcher, {
    revalidateOnFocus: false,
    shouldRetryOnError: false,
    onError: (e) => {
      let error = e;
      if (!(error instanceof InviteError)) {
        captureException(error);
        error = new InviteError(undefined);
      }
      onError(error);
    },
  });
}
